<template>
    <div>
        <section class="base-header-sec base-header-laen laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="base-header__container">
                    <div class="d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Претрага неважећих исправа
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" @reset="reset" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Врста исправе:</label>
                                <select v-model="documentType" class="form-control full-width">
                                    <option value="">Све врсте докумената</option>
                                    <option v-for="item in documentTypes" v-bind:key="item.id" :value="item.documentKind">
                                        {{ item.documentKind }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Број исправе:</label>
                                <input type="text" v-model="documentNumber" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Име и презиме физичког лица/Назив правног лица:</label>
                                <input type="text" v-model="beneficiaryName" class="form-control full-width">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <data-picker-mask-component v-if="renderComponent" :setDateFrom=setDateFrom :setDateTo=setDateTo
                                ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control" type="number">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <!--                            :disabled="!validData"-->
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="reset" class="btn btn-base-reset text-uppercase">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <result-counter :count="resultSize" :limit="limit"></result-counter>
            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">
                    <template v-slot:cell(beneficiaryMunicipality)="data">
                        {{ data.item.beneficiaryMunicipality }}
                        <span v-if="data.item.beneficiaryCity && data.item.beneficiaryMunicipality">/</span>
                        {{ data.item.beneficiaryCity }}

                    </template>
                    <template v-slot:cell(ogNumber)="data">
                        Службени гласник РС {{ data.item.ogNumber }}/{{ data.item.ogYear }}

                    </template>
                    <template v-slot:cell(ogPublishDate)="data">
                        {{ moment(data.item.ogPublishDate).format('DD.MM.YYYY') }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>


 

<script>

import axios from 'axios';
// import Datepicker               from 'vuejs-datepicker';
import { srCYRL } from 'vuejs-datepicker/dist/locale'
// import {SortedTable, SortLink} from "vue-sorted-table"
import ResultCounter from '@/partials/ResultCounter.vue';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
import moment from 'moment';

export default {
    name: "FpSearchNadjiMo",
    data() {
        return {
            limit: 50,
            renderComponent: true,
            sortBy: 'ogPublishDate',
            sortDesc: true,
            fields: [
                { label: 'Име и презиме', key: 'beneficiaryName', sortable: true },
                { label: 'Врста исправе', key: 'documentKind', sortable: true },
                { label: 'Број исправе', key: 'documentNumber', sortable: true },
                { label: 'Издавалац исправе', key: 'documentIssuer', sortable: true },
                { label: 'Општина / место', key: 'beneficiaryMunicipality', sortable: true },
                { label: 'Гласило у ком је објављен', key: 'ogNumber', sortable: true },
                { label: 'Датум објаве', key: 'ogPublishDate', sortable: true },
            ],
            emitedDateFromVal: null,
            emitedDateToVal: null,
            srCYRL: srCYRL,
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            resultLimit: 50,
            baseApiUrl: window.env.VUE_APP_API_CODEBOOK_DEV,
            documentApiUrl: window.env.VUE_APP_API_CODEBOOK_DEV + 'prins/api/nadjiMo/documentKinds',
            searchApiUrl: window.env.VUE_APP_API_DI_DEV + 'MO/SearchMO',

            // http://10.10.22.36:8080/SlGlasnikPortal/api/nadjiMo/search

            documentType: "",
            documentNumber: null,
            beneficiaryName: null,
            dateFrom: null,
            dateTo: null,

            documentTypes: [],
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        setDateFrom: {
            get() {
                return moment().subtract(6, 'months').format('YYYY-MM-DD');
            },
            set(newDate) {
                return newDate
            }
        },
        setDateTo: {
            get() {
                return moment().format('YYYY-MM-DD');
            },
            set(newDate) {
                return newDate
            }
        },
        // setDateFrom:function () {
        //     return moment().subtract(6, 'months').format('YYYY-MM-DD');
        // },
        // setDateTo:function () {
        //     return moment().format('YYYY-MM-DD');
        // },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        },
        validData: function () {
            return this.dateFrom !== null && this.dateTo !== null;
        }
    },
    methods: {
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;
            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        },
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        fetchData() {
            axios.get(this.documentApiUrl)
                .then(response => {
                    console.log(response);
                    this.documentTypes = response.data.actualDocumentKinds;
                })
        },
        search() {
            axios.post(this.searchApiUrl, this.getSearchParams())
                .then(response => {
                    this.resultSize = response.data.resultSize;
                    this.result = response.data.result;
                    this.limit = this.resultLimit;
                })
        },
        getSearchParams() {
            return {
                resultLimit: this.resultLimit,
                beneficiaryName: this.beneficiaryName,
                documentNumber: this.documentNumber,
                documentKind: this.documentType,
                // ogPublishDateFrom: this.dateFrom,
                // ogPublishDateTo: this.dateTo,
                //moment().subtract(6, 'months').format('YYYY-MM-DD')
                ogPublishDateFrom: moment(this.emitedDateFromVal).format('YYYYMMDD'),
                ogPublishDateTo: moment(this.emitedDateToVal).format('YYYYMMDD')
            }
        },
        reset(event) {
            event.preventDefault();
            this.beneficiaryName = null;
            this.documentNumber = null;
            this.resultSize = null;
            // this.dateFrom = null;
            // this.dateTo = null;
            this.documentType = "";
            // this.documentTypes.shift();
            // this.emitedDateFromVal = null;
            // this.emitedDateToVal = null;
            this.limit = null;
            this.resultLimit = 50;
            //TODO
            // this.documentType = 1;

            this.result = [];
            this.forceRerender();
            this.$refs.dataPickerMask.resetDate(moment().subtract(6, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));


            // this.setDateFrom = moment().subtract(6, 'months').format('YYYY-MM-DD');
            // this.setDateTo = moment().format('YYYY-MM-DD');


        }
    },
    mounted() {
        this.fetchData()
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}

</script>

<style scoped></style>
